// extracted by mini-css-extract-plugin
module.exports = {"color-black":"#000000","colorBlack":"#000000","button":"_3ZZWU _1R_Wx"};